import Vue from 'vue';

Vue.filter('porcentaje', function(value: number) {
    if(!value) return;
    return (value).toFixed(2) + "%"
});

Vue.filter('nodecimal', function(value: number, decimals: number = 0, unidad: string = ""){
    if(!value) return;
    const output = value.toFixed(decimals);
    return !unidad ? output : `${output} ${unidad}`
})